// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.feedback-tools__content[data-v-63e60190] {\n  background-color: #fff;\n}\n.feedback-tools__header[data-v-63e60190] {\n  overflow: auto;\n}\n.feedback-tools__delimiter[data-v-63e60190] {\n  position: relative;\n  left: 30px;\n  z-index: 2;\n  display: block;\n  width: calc(100% - 60px);\n  height: 0.5px;\n  background-color: #e9e9ee;\n}\n", ""]);
// Exports
module.exports = exports;
